import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Grid, Typography, Paper, Button } from '@mui/material';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';

const FarmDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [farm, setFarm] = useState(null);

  useEffect(() => {
    const fetchFarm = async () => {
      try {
        const response = await axios.get(`https://sense-agro-backend.onrender.com/api/farm/${id}`);
        setFarm(response.data);
      } catch (error) {
        console.error('Erro ao buscar dados da fazenda:', error);
      }
    };

    fetchFarm();
  }, [id]);

  if (!farm) return <Typography sx={{ p: 2 }}>Fazenda não encontrada.</Typography>;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>Detalhes da Fazenda</Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Nome</Typography>
            <Typography>{farm.nome}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Cultura Principal</Typography>
            <Typography>{farm.culturaPrincipal}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Outras Culturas</Typography>
            <Typography>{farm.outrasCulturas || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Hectares Plantados</Typography>
            <Typography>{farm.hectaresPlantados} ha</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2">Hectares Total</Typography>
            <Typography>{farm.hectaresTotal} ha</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Endereço</Typography>
            <Typography>{farm.endereco}</Typography>
          </Grid>
        </Grid>
      </Paper>

      <Typography variant="h6" gutterBottom>Localização no Mapa</Typography>
      <Paper sx={{ height: 300, mb: 3 }}>
        <MapContainer
          center={[farm.latitude, farm.longitude]}
          zoom={13}
          style={{ height: '100%', width: '100%' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[farm.latitude, farm.longitude]} />
        </MapContainer>
      </Paper>

      <Button variant="outlined" onClick={() => navigate(-1)}>Voltar</Button>
    </Box>
  );
};

export default FarmDetails;
